// extracted by mini-css-extract-plugin
export default {"wrapper":"djMXZM9pqnLEHssIOgEA","content":"ugPgRJxoMdlTgmMkQpEj","title":"yw3RvoKUwbbc8Q43fzZh","panelIcon":"q55mX8i5Si6sh_isgJhX"};